import type { unstable_usePrompt as Prompt } from "react-router-dom";
// eslint-disable-next-line import/no-mutable-exports
let output: typeof Prompt = () => null;
try {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const router = require("react-router-dom");
  output = router.unstable_usePrompt;
} catch (e) {
  output = () => null;
}

export default output;
